
import React from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Badge } from '@/components/ui/badge';
import { AlertTriangle, Users } from 'lucide-react';

interface DuplicateValidationProps {
  duplicateEmails: string[];
  internalDuplicates: string[];
}

export const DuplicateValidation = ({ duplicateEmails, internalDuplicates }: DuplicateValidationProps) => {
  if (duplicateEmails.length === 0 && internalDuplicates.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      {duplicateEmails.length > 0 && (
        <Alert className="border-orange-200 bg-orange-50">
          <AlertTriangle className="h-4 w-4 text-orange-600" />
          <AlertDescription className="text-orange-800">
            <div className="space-y-2">
              <p className="font-medium">
                {duplicateEmails.length} email(s) already exist in import records:
              </p>
              <div className="flex flex-wrap gap-1">
                {duplicateEmails.map((email, index) => (
                  <Badge key={index} variant="outline" className="text-orange-700 border-orange-300">
                    {email}
                  </Badge>
                ))}
              </div>
              <p className="text-sm">These records will not be imported.</p>
            </div>
          </AlertDescription>
        </Alert>
      )}

      {internalDuplicates.length > 0 && (
        <Alert className="border-red-200 bg-red-50">
          <Users className="h-4 w-4 text-red-600" />
          <AlertDescription className="text-red-800">
            <div className="space-y-2">
              <p className="font-medium">
                {internalDuplicates.length} duplicate email(s) found within the CSV:
              </p>
              <div className="flex flex-wrap gap-1">
                {internalDuplicates.map((email, index) => (
                  <Badge key={index} variant="outline" className="text-red-700 border-red-300">
                    {email}
                  </Badge>
                ))}
              </div>
              <p className="text-sm">Only the first occurrence of each email will be imported.</p>
            </div>
          </AlertDescription>
        </Alert>
      )}
    </div>
  );
};
